export default __webpack_public_path__ + "static/media/Leadership.898e4f1b.png";